import React from 'react';
import AssetTeamNavBar from '../../../../layouts/asset-team/AssetTeamNavBar';
import QualityAssuranceBody from './QualityAssuranceBody';

const QualityAssuranceHeader = () => {
  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        < AssetTeamNavBar currentPage="Quality Assurance" />
        <QualityAssuranceBody />
      </main>
    </div>
  );
};

export default QualityAssuranceHeader;